import PrecallSurvey from '@components/pages/account/survey/PrecallSurvey';
import { SurveyStep } from '@components/pages/account/survey/PrecallSurvey/constants';

export const PrecallProviders = () => <PrecallSurvey step={SurveyStep.PROVIDER} />;

export default PrecallProviders;
